var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignedProjectMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_545)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99316 20.9991C5.99316 16.0286 10.0226 11.9991 14.9931 11.9991C19.9638 11.9991 23.9932 16.0286 23.9932 20.9991C23.9932 25.9697 19.9638 29.9991 14.9931 29.9991C10.0226 29.9991 5.99316 25.9697 5.99316 20.9991Z",
    fill: "black",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.57143C0 3.83756 3.83756 0 8.57143 0H21.4286C26.1624 0 30 3.83756 30 8.57143V21.4286C30 26.1624 26.1624 30 21.4286 30H8.57143C3.83756 30 0 26.1624 0 21.4286V8.57143Z",
    fill: "url(#paint0_radial_62_545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9284 23.5151C9.08646 22.5172 6.27167 18.9492 6.43551 14.7672C6.60915 10.2601 10.2603 6.60883 14.7674 6.43519C18.9492 6.27379 22.5173 9.08863 23.515 12.9282C23.8011 14.0336 22.9647 15.1121 21.8228 15.1121H21.8155C21.0132 15.1121 20.326 14.5618 20.1207 13.7866C19.5094 11.4828 17.3498 9.80274 14.8285 9.93724C12.2021 10.0767 10.0769 12.2019 9.93752 14.8284C9.80301 17.3498 11.4831 19.5092 13.7843 20.1182C14.5596 20.3236 15.1099 21.0108 15.1099 21.813V21.8203C15.1099 22.9625 14.0313 23.8012 12.9284 23.5151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8857 15.4064C16.9756 15.4064 17.8593 14.5228 17.8593 13.4329C17.8593 12.3429 16.9756 11.4593 15.8857 11.4593C14.7957 11.4593 13.9121 12.3429 13.9121 13.4329C13.9121 14.5228 14.7957 15.4064 15.8857 15.4064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_545",
    x: 0.993164,
    y: 6.99915,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.643137 0 0 0 0 0.737255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_62_545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 30) rotate(-90) scale(30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AA4BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedProjectMarker);
export default __webpack_public_path__ + "static/media/signedProjectMarker.ccee53f19542c77d66e47656f0563ce5.svg";
export { ForwardRef as ReactComponent };